import { render, staticRenderFns } from "./MyPageReal.vue?vue&type=template&id=19e43378&scoped=true"
import script from "./MyPageReal.vue?vue&type=script&lang=js"
export * from "./MyPageReal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e43378",
  null
  
)

export default component.exports